export const GET_SALES_REPORT = 'GET_SALES_REPORT';
export const GET_SALES_REPORT_ERROR = 'GET_SALES_REPORT_ERROR';
export const GET_SALES_REPORT_REQUEST = 'GET_SALES_REPORT_REQUEST';
export const GET_SALES_REPORT_SUCCESS = 'GET_SALES_REPORT_SUCCESS';

export const GET_STOCKS_REPORT = 'GET_STOCKS_REPORT';
export const GET_STOCKS_REPORT_ERROR = 'GET_STOCKS_REPORT_ERROR';
export const GET_STOCKS_REPORT_REQUEST = 'GET_STOCKS_REPORT_REQUEST';
export const GET_STOCKS_REPORT_SUCCESS = 'GET_STOCKS_REPORT_SUCCESS';

export const SET_REPORT = 'SET_REPORT';
